import { mobilityOfferExists } from '../admin.utils';

function getMobilityOfferIcon(mobilityOffer) {
  if (mobilityOffer?.verified === false) {
    return 'mobility-warning.svg';
  }

  if (!mobilityOfferExists(mobilityOffer)) {
    return 'no-mobiliteitsaanbod.svg';
  }

  return 'mobiliteitsaanbod.svg';
}

export {
  getMobilityOfferIcon,
};